// External libraries
import { action } from 'easy-peasy';

const getUserState = overrides => ({
  isUserLoggedIn: false,
  ...overrides,
});

const createUserActions = () => ({
  setUserLoggedIn: action(state => {
    state.isUserLoggedIn = true;
  }),
  setUserLoggedOut: action(state => {
    state.isUserLoggedIn = false;
  }),
});

const userModelFactory = () => ({
  ...getUserState(),
  ...createUserActions(),
});

export { getUserState, userModelFactory };
